import { cn } from "./cn";

/** A small square-ish counter: for nav rows, tabs and segments. */
export function Count({ value, active, tone, className }: { value: number | string; active?: boolean; tone?: "bad" | "brand"; className?: string }) {
  return (
    <span
      className={cn(
        "relative inline-grid h-5 min-w-5 place-items-center rounded-chip px-1.5 text-[11px] font-bold leading-none tabular-nums transition-[background-color,color] duration-150",
        tone === "bad"
          ? "bg-bad text-white"
          : tone === "brand"
            ? "bg-accent text-on-accent"
            : active
              ? "bg-primary text-on-primary"
              : "bg-ink/[0.07] text-ink-soft",
        className,
      )}
    >
      {value}
    </span>
  );
}
